export const isValidAmount = (input: string, total: string) => {
  return parseFloat(total) - parseFloat(input) >= 0;
};
